const SESSION_STORAGE_KEYS = {
  ACTIVE_PROJECT_ID: 'ACTIVE_PROJECT_ID',
}

export const setSessionActiveProjectId = projectId => {
  sessionStorage.setItem(SESSION_STORAGE_KEYS.ACTIVE_PROJECT_ID, projectId)
}
export const getSessionActiveProjectId = () => sessionStorage.getItem(SESSION_STORAGE_KEYS.ACTIVE_PROJECT_ID)
